import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { cn } from "@omni/utils/styles";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { ShoppingCartItem } from "../shoppingCartItem/shoppingCartItem.component";

type ProductGroupComponentProps = {
    title: string;
    icon: string;
    cartItems: CartItem[];
    shopName?: string;
    isMiniCart: boolean;
    loading: boolean;
    isClickAndCollect: boolean;
    removeFromCart?: (id: string, quantity: number, free: boolean) => void;
    productLinkingAvailable?: boolean;
};

const ProductGroupComponent = ({
    cartItems,
    icon,
    title,
    shopName,
    isMiniCart,
    loading,
    isClickAndCollect = false,
    removeFromCart,
    productLinkingAvailable
}: ProductGroupComponentProps) => {
    const { t } = useGranite();

    return (
        <section>
            {!isMiniCart && (
                <>
                    <h3 className={cn("tw:bg-grey tw:py-4 tw:px-2")}>
                        <i className={cn(`las ${icon} la-lg`, "tw:mr-1")} />
                        {t(title)}
                    </h3>
                    {isClickAndCollect && !!shopName && (
                        <p className={cn("tw:mt-2")}>
                            {t("general.cart.label.currentStore", shopName)}
                        </p>
                    )}
                </>
            )}
            {isMiniCart && (
                <div className={cn("tw:bg-grey tw:py-1 tw:px-2")}>
                    <i className={cn(`las ${icon} la-lg`, "tw:mr-1")} />
                    {t(title)}
                </div>
            )}
            <div>
                {cartItems.map((productObject) => (
                    <ShoppingCartItem
                        cartItem={productObject}
                        key={productObject.id}
                        productLinkingAvailable={!!productLinkingAvailable}
                        loading={loading}
                        removeFromCart={removeFromCart}
                    />
                ))}
            </div>
        </section>
    );
};

export default ProductGroupComponent;
